import packageInfo from '../package.json';

const app = {
  version: packageInfo.version,
  name: 'Crimson',
  logoUrl: '/logo-text-black.svg',
  logoUrlOnDark: '/logo-text-white.svg',
};

export default app;
